import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  CircularProgress,
  Backdrop
} from "@mui/material";

import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import { FilePaymentReducerAction } from "../Store/FilePayment/FilePaymentReducer";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CustomTextField from "../CustomComponents/CustomTextField";
import CustomDateField from "../CustomComponents/CustomDateField";
import store from "../Store/index";
import { ArrowBack, ArrowForward, Delete } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import NoDataFound from "../CustomComponents/NoDataFound";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
const FilePaymentDetail = () => {
  //Getting value from store
  const rows = useSelector((state) => state.filePayment.gridValues.rows);
  //Gettong filter values
  const filterValues = useSelector((state) => state.filePayment.filterValues);
  //Initial state
  const rowsPerPage = 10;
  const [datarows, setRows] = React.useState([]);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  //Code which maintain opening and closing Dialog
  const [Dialogopen, setDialogOpen] = useState(false);
  //maintaining Debit Amount
  const [page, setPage] = React.useState(1);
  //code for maintaining validation dialog
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationDialogTitle, setValidationDialogTitle] = useState("");
  const [validationDialogContent, setValidationDialogContent] = useState("");
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  //State for maintaining Confirmation Dialog
  const [confirmationDialogOpen, setConfirmationDialogopen] = useState(false);
  const [confirmationDialogTitle, setConfirmationDialogTitle] = useState("");
  const [confirmationDialogContent, setConfirmationDialogContent] =
    useState("");
  const [pageSize, setPageSize] = useState(10);
  const [yesButtonDisableHandler, setYesButtonDisableHandler] = useState(false);
  //Dialog button state
  const [informationDialogOkButton, setinformationDialogOkButton] =
    useState(true);
  //Use Dispatch)
  const dispatch = useDispatch();
  let applicationArray = useSelector(
    (state) => state.filePayment.gridValues.applicationNumberArray
  );

  const GLAccountArray = useSelector(
    (state) => state.filePayment.gridValues.GLAccountArray
  );
  const glDisplay = useSelector(
    (state) => state.filePayment.HideComponents.glDisplay
  );

  const brachArrayWithCode = useSelector(
    (state) => state.filePayment.filterValues.brachArrayWithCode
  );
  const [accordianOpen, setAccordianOpen] = useState(true);

  //Getting modal value for binding record on the model
  const modalValues = useSelector((state) => state.filePayment.modalValue);

  const allBranchGlAccounts = useSelector(
    (state) => state.filePayment.gridValues.allBranchGlAccounts
  );
  const GLResponseData = useSelector(
    (state) => state.filePayment.gridValues.GLValAndDesArray
  );
  //Maintaining Selected RowID
  const [activeRowID, setActiveRowID] = useState("");

  //Getting UserName
  const [userName, setUserName] = useState("");

  //Save Button Disabled State
  const [saveButtonDisable, setSaveButtonDisable] = useState(true);
  const [dialogTitleMode, setDialogTitleMode] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  //shortcut key
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const historyRef = useRef(null);
  const historyCellRef = useRef(null);
  const addRowRef = useRef(null);
  const saveRef = useRef(null);

  const deleteRowRef = useRef(null);
  const okRef = useRef(null);
  const okValRef = useRef(null);
  const okInfoRef = useRef(null);
  //Dialog mode
  const [informationDialogFlag, setInformationDialogFlag] = useState(false);
  const [informationDialogTitle, setInformationDialogTitle] = useState("");
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [dialogTitleMode, informationDialogOkButton]);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "filePaymentDetail",
        })
      );
    }
  };
  const checkGlPaymentReceipt = async (appNum, glAccount) => {
    try {
      const response = await axios.post("/filepayment/checkPaymentGlReceipt", {
        applicationNum: appNum,
        glAccount: glAccount,
      });
      return response;
    } catch (e) {
      console.log("Network Error");
    }
  };
  const checkPaymentGlReceiptAmount = async (appNum, glAccount, amount) => {
    try {
      const response = await axios.post(
        "/filepayment/checkPaymentGlReceiptAmount",
        {
          applicationNum: appNum,
          glAccount: glAccount,
          amount: amount,
        }
      );
      return response;
    } catch (e) {
      console.log("Network Error");
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      saveRef: saveRef,
    };
    if (event.key === "Escape" || event.keyCode === 27) {
      if (dialogTitleMode === "BankDetails") {
        setDialogOpen(false);
      }
      if (dialogTitleMode === "ValidationDialogMode") {
        if (informationDialogOkButton) {
          setValidationDialogOpen(false);
        } else {
          window.location.reload(true);
          setValidationDialogOpen(false);
        }
      }
      if (dialogTitleMode === "ConfirmationDialogMode") {
        setConfirmationDialogopen(false);
      }
    } else if (event.ctrlKey) {
      switch (charCode) {
        case "s":
          saveRef.current.click();
          break;
        case "k":
          okRef.current?.click();
          okInfoRef.current?.click();
          okValRef.current?.click();

          break;
        case "y":
          yesRef.current?.click();
          break;
        case "q":
          cancelRef.current?.click();
          break;
        case "r":
          deleteRowRef.current.click();
          break;
        case "h":
          historyRef.current?.click();
          historyCellRef.current?.click();
          break;
        case "a":
          addRowRef.current.click();
          break;
      }
    }
  };
  useEffect(() => {
    const users = store.getState().branch.userName;
    setUserName(users);
  }, []);
  useEffect(() => {
    setRows([...rows].slice(0, 10));
    setTotalPageCount(
      rows.length % 10 !== 0
        ? Number(Number((rows.length / 10).toString().split(".")[0]) + 1)
        : Number(Number((rows.length / 10).toFixed()))
    );
    setTotalRowsCount(rows.length);

    setPage(1);
  }, [rows]);

  const columnsData = [
    {
      field: "applicationBranch",
      headerName: "Branch",
      headerAlign: "center",
      flex: 200,
      align: "left",
      editable: true,
      type: "singleSelect",
      valueOptions: filterValues.branch.map((data) => data.label),
    },
    {
      field: "applicationNumber",
      headerName: "Application Number",
      headerAlign: "center",
      flex: 200,
      editable: true,
      align: "left",
      type: "singleSelect",
      valueOptions: applicationArray,
    },
    {
      field: "glAccount",
      headerName: "GL Account",
      headerAlign: "center",
      align: "left",
      disableColumnMenu: true,
      flex: 200,
      editable: glDisplay,
      type: "singleSelect",
      valueOptions: GLAccountArray,
    },
    {
      field: "description",
      headerName: "GL Account Description",
      headerAlign: "center",
      flex: 200,
      align: "left",
      disableColumnMenu: true,
    },
    // {
    //   field: "favourName",
    //   headerName: "Favour Name",
    //   headerAlign: "center",
    //   flex: 200,
    //   align: "left",
    //   type: "singleSelect",
    //   valueOptions: favourNameArray,
    //   editable: true,
    // },
    {
      field: "debitAmount",
      headerName: "Debit Amount",
      headerAlign: "center",
      align: "right",
      flex: 150,
      editable: true,
      type: "number",
    },
    {
      field: "actions",
      headerName: "Bank Details",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "action",
      renderCell: (params) => {
        if (params.row.applicationNumber) {
          return (
            <Tooltip title="Bank Details">
              <IconButton
                onClick={() => {
                  customerBankDetailDialogHandler(params);
                }}
              >
                <AccountBalanceIcon />
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      disableColumnMenu: true,
      sortable: false,

      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];
  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);

    setRows([...rows].slice(offset, offset + rowsPerPage));
  };
  const gridRowAddButtonHandler = () => {
    if (rows.length > 0) {
      let result = true;
      rows.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          if (!["emiStartDate", "emiAmt", "fundTransferMode"].includes(key)) {
            if (
              obj[key] === "" ||
              obj[key] === undefined ||
              obj[key] === null
            ) {
              result = false;
            }
          }
        });
      });
      if (result) {
        dispatch(FilePaymentReducerAction.updateGlDisplay(false));
        dispatch(FilePaymentReducerAction.updateApplicationDisplay(false));

        dispatch(FilePaymentReducerAction.updateApplicationArray([]));
        dispatch(
          FilePaymentReducerAction.addRows({
            id: Math.floor(Math.random() * 100),
            branch: filterValues.branchValue.label,
            branchCode: filterValues.branchCode,
            applicationBranchCode: filterValues.branchCode,
            applicationBranch: filterValues.branchValue.label,
            applicationNumber: "",
            glAccount: "",
            description: "",
            debitAmount: "",
            paymentBankOrCash: filterValues.paymentBankOrCash,
            paymentBankCode: filterValues.paymentBankCode,
            paymentBankBranchKey: filterValues.paymentBankBranchKey,
            fundTransferMode: filterValues.fundTransferMode,
            customerName: "",
            bankName: "",
            bankBranchName: "",
            ifsc: "",
            bankAccNum: "",
            emiAmt: "",
            emiStartDate: "",
            accountType: "",
            approvalFlg: false,

            // favourNameArray: [],
            //bankDetailArray: [],
            // favourName: "",
            paymentType: filterValues.paymentType,
            paymentCode: filterValues.paymentCode,
            voucherDate: filterValues.voucherDate,
            // depositBank: filterValues.depositBank,
            screenMode: "CREATE",
            createdBy: userName,
            lastModifiedBy: userName,
          })
        );
      } else {
        setinformationDialogOkButton(true);
        setDialogTitleMode("ValidationDialogMode");
        setValidationDialogTitle("Information");
        setValidationDialogContent("Please Enter all Required Fields");
        setValidationDialogOpen(true);
      }
    } else {
      dispatch(FilePaymentReducerAction.updateGlDisplay(false));
      dispatch(FilePaymentReducerAction.updateApplicationDisplay(false));

      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
      dispatch(
        FilePaymentReducerAction.addRows({
          id: Math.floor(Math.random() * 100),
          branch: filterValues.branchValue.label,
          branchCode: filterValues.branchCode,
          applicationBranchCode: filterValues.branchCode,
          applicationBranch: filterValues.branchValue.label,
          applicationNumber: "",
          glAccount: "",
          description: "",
          debitAmount: "",
          paymentBankOrCash: filterValues.paymentBankOrCash,
          paymentBankCode: filterValues.paymentBankCode,
          paymentBankBranchKey: filterValues.paymentBankBranchKey,
          fundTransferMode: filterValues.fundTransferMode,
          customerName: "",
          bankName: "",
          bankBranchName: "",
          ifsc: "",
          bankAccNum: "",
          emiAmt: "",
          emiStartDate: "",
          accountType: "",
          approvalFlg: false,

          // favourNameArray: [],
          //bankDetailArray: [],
          // favourName: "",
          paymentType: filterValues.paymentType,
          paymentCode: filterValues.paymentCode,
          voucherDate: filterValues.voucherDate,
          // depositBank: filterValues.depositBank,
          screenMode: "CREATE",
          createdBy: userName,
          lastModifiedBy: userName,
        })
      );
    }
  };
  //Delete Button Handler
  const deleteSelectedRow = (params) => {
    const filteredValue = rows.filter((data) => {
      return data.id !== params.id;
    });
    dispatch(FilePaymentReducerAction.updateRows(filteredValue));
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const getAppListByBranch = async (value) => {
    const branchCodeValue = getSelectedBranchCode(value);
    const response = await axios.post("/losCustomer/getAppListByBranch", {
      branchName: value,
      branchCode: branchCodeValue,
      screenMode: "CREATE",
    });
    dispatch(FilePaymentReducerAction.updateApplicationArray(response.data));
  };
  const getGlAccountsBasedOnBranch = (branch) => {
    const selectedBranch = filterValues.brachArrayWithCode.find((branchVal) => {
      return branchVal.label === branch;
    });
    const GlDetails = allBranchGlAccounts[selectedBranch.code];
    const GLValAndDesArray = GlDetails.ledger_details.map((data) => data);
    dispatch(FilePaymentReducerAction.updateGLValAndDesArray(GLValAndDesArray));

    const GlAccount = GlDetails.ledger_details.map((data) => {
      return `${data["account_head"]} - ${data["account_desc"]}`;
    });
    dispatch(FilePaymentReducerAction.updateGLAccountArray(GlAccount));
  };
  const cellDoubleClickHandler = (params) => {
    const dataIndex = rows.findIndex((data) => {
      return data.id === params.id;
    });

    const activeRow = rows[dataIndex];
    if (params.field === "applicationNumber") {
      getAppListByBranch(activeRow.applicationBranch);
    }
    if (params.field === "glAccount") {
      getGlAccountsBasedOnBranch(activeRow.applicationBranch);
    }
  };
  //Cell Change Handler
  const cellChangeHandler = async (params) => {
    const dataIndex = rows.findIndex((data) => {
      return data.id === params.id;
    });
    let data = rows[dataIndex];
    if (params.field === "applicationNumber") {
      setSaveButtonDisable(true);
      bindCustomerData(data, params, dataIndex);
      dispatch(FilePaymentReducerAction.updateGlDisplay(true));
    } else if (params.field === "applicationBranch") {
      dispatch(FilePaymentReducerAction.updateApplicationDisplay(true));

      setSaveButtonDisable(true);
      const branchCode = brachArrayWithCode.find((branch) => {
        return params.value === branch.label;
      });
      const datas = {
        ...data,
        applicationBranch: params.value,
        applicationNumber: "",
        glAccount: "",
        description: "",
        debitAmount: "",
        applicationBranchCode: branchCode.code,
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentReducerAction.updateRows(newItem));
    } else if (params.field === "glAccount") {
      setSaveButtonDisable(false);
      const activeRowValue = rows.find((data) => {
        return data.id === activeRowID;
      });

      const filterValue = rows.map((data) => {
        return activeRowValue.applicationNumber === data.applicationNumber
          ? data
          : "";
      });
      let clearFlag;
      if (
        `${activeRowValue.glAccount} - ${activeRowValue.description}` ===
        params.value
      ) {
        clearFlag = false;
      } else {
        filterValue.forEach((data) => {
          const retrivalData = GLResponseData.find((data) => {
            return (
              `${data["account_head"]} - ${data["account_desc"]}` ===
              params.value
            );
          });

          if (data.glAccount === retrivalData.account_head) {
            clearFlag = true;
          }
        });
      }

      let datas;
      if (clearFlag) {
        setinformationDialogOkButton(true);
        setDialogTitleMode("ValidationDialogMode");
        setValidationDialogTitle("Information");
        setValidationDialogContent(
          `Duplicate GL Accounts can’t be added. Please edit the amount if needed on existing row.`
        );
        setValidationDialogOpen(true);
        datas = {
          ...data,
          glAccount: "",
          description: "",
          debitAmount: "",
        };
      } else {
        const retrivalData = GLResponseData.find((data) => {
          return (
            `${data["account_head"]} - ${data["account_desc"]}` === params.value
          );
        });
        const response = await checkGlPaymentReceipt(
          activeRowValue.applicationNumber,
          retrivalData.account_head
        );
        if (response.data.status === 1) {
          datas = {
            ...data,
            glAccount: retrivalData.account_head,
            description: retrivalData.account_desc,
          };
        } else {
          datas = {
            ...data,
            glAccount: "",
            description: "",
          };
          setInformationDialogFlag(true);
          setInformationDialogTitle(response.data.message);
        }
      }

      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentReducerAction.updateRows(newItem));
    } else if (params.field === "debitAmount") {
      const response = await checkPaymentGlReceiptAmount(
        data.applicationNumber,
        data.glAccount,
        params.value
      );
      let datas;
      if (response.data.status === 1) {
        datas = {
          ...data,
          debitAmount:
            params.value <= 0 || Number(params.value) > 99999999
              ? 0
              : Math.floor(params.value),
        };
      } else {
        datas = {
          ...data,
          debitAmount: 0,
        };
        setInformationDialogFlag(true);
        setInformationDialogTitle(response.data.message);
      }

      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentReducerAction.updateRows(newItem));
    } else {
      if (params.field !== "debitAmount") {
        const datas = { ...data, [params.field]: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        dispatch(FilePaymentReducerAction.updateRows(newItem));
      }
    }
  };
  //Binding customer data
  const bindCustomerData = async (data, params, dataIndex) => {
    try {
      const response = await axios.post(
        "/losCustomer/getCustBankDetailsByAppNum",
        {
          applicationNum: params.value,
        }
      );
      const emiResponse = await axios.post("/filepayment/getDisbEmiData", {
        applicationNum: params.value,
      });

      const customerBankDetails = response.data[0];
      const datas = {
        ...data,
        applicationNumber: params.value,
        debitAmount: "",
        emiStartDate:
          emiResponse.data.emiStartDate !== undefined
            ? emiResponse.data.emiStartDate
            : null,
        emiAmt:
          emiResponse.data.emiAmt !== undefined ? emiResponse.data.emiAmt : "",
        customerName: customerBankDetails.accHoldrName,
        bankName: customerBankDetails.bankName,
        bankBranchName: customerBankDetails.bankBranchName,
        accountType: customerBankDetails.bankAccountType,
        ifsc: customerBankDetails.ifscCode,
        bankAccNum: customerBankDetails.bankAccountNum,
        description: "",
        glAccount: "",
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentReducerAction.updateRows(newItem));
    } catch {
      const datas = {
        ...data,
        description: "",
        debitAmount: "",
        glAccount: "",
        applicationNumber: params.value,
        customerName: "",
        bankName: "",
        bankBranchName: "",
        ifsc: "",
        bankAccNum: "",
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentReducerAction.updateRows(newItem));
    }
  };
  //CustomerBankDetailDialogHandler
  const customerBankDetailDialogHandler = (params) => {
    dispatch(FilePaymentReducerAction.updateModalValue(params.row));
    setDialogTitleMode("BankDetails");
    setDialogOpen(true);
  };

  const dummySaveButtonHandler = async () => {
    if (rows.length > 0) {
      let result = true;
      rows.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          if (!["emiStartDate", "emiAmt", "fundTransferMode"].includes(key)) {
            if (
              obj[key] === "" ||
              obj[key] === undefined ||
              obj[key] === null
            ) {
              result = false;
            }
          }
        });
      });
      if (result) {
        let debitStatusFlag = false;
        rows.forEach((data) => {
          if (data.debitAmount <= 0) {
            debitStatusFlag = true;
          }
        });
        if (debitStatusFlag) {
          setinformationDialogOkButton(true);
          setDialogTitleMode("ValidationDialogMode");

          setValidationDialogTitle("Information");
          setValidationDialogContent("Please Enter Valid Debit Amount");
          setValidationDialogOpen(true);
        } else {
          await isPaymentForMultiCustomerIdValidation();
        }
      } else {
        setinformationDialogOkButton(true);
        setDialogTitleMode("ValidationDialogMode");

        setValidationDialogTitle("Information");
        setValidationDialogContent("Please Enter all Required Fields");
        setValidationDialogOpen(true);
      }
    }
  };

  const isPaymentForMultiCustomerIdValidation = async () => {
    setSaveButtonDisable(true);
    try {
      const response = await axios.post(
        "/filepayment/isPaymentMultiCustomerId",
        rows
      );
      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.isMultiCustomerId) {
          // error case -> show error info dialog to user.
          setinformationDialogOkButton(true);
          setDialogTitleMode("ValidationDialogMode");

          setValidationDialogTitle("Information");
          setValidationDialogContent(
            "File Payment Not Allowed for Multiple Customer Id's."
          );
          setValidationDialogOpen(true);
          setSaveButtonDisable(false);
        } else {
          //positive case proceed with user confirmation for save.
          setDialogTitleMode("ConfirmationDialogMode");
          setConfirmationDialogopen(true);
          setConfirmationDialogTitle("Confirmation");
          setConfirmationDialogContent("Confirmation for Payment Create ?");
        }
      }
    } catch (error) {
      setSaveButtonDisable(false);
    }
  };

  const confirmationDialogOkButtonHandler = () => {
    setYesButtonDisableHandler(true);
    dummySendData();
  };

  const dummySendData = async () => {
    setSaveButtonDisable(true);
    setConfirmationDialogopen(false);
    try {
      setLoading(true)
      setLoadingMsg("Creating File Payment Please wait...")
      const response = await axios.post("/filepayment/insertFilePayment", rows);
      if (response.status === 200) {
        setLoading(false)
        if (response.data.voucherSeqGenerated) {
          setDialogTitleMode("ValidationDialogMode");
          setConfirmationDialogopen(false);
          setinformationDialogOkButton(false);
          setValidationDialogTitle("Information");
          setValidationDialogContent(
            `File Payment Created Successfully. Voucher Number : (${response.data.paymentData[0].voucherNumber})`
          );
          setValidationDialogOpen(true);
        } else {
          setDialogTitleMode("ValidationDialogMode");
          setConfirmationDialogopen(false);
          setinformationDialogOkButton(false);
          setValidationDialogTitle("Information");
          setValidationDialogContent(
            `Not able to save details, Payment Charset is not generated yet.`
          );
          setValidationDialogOpen(true);
        }
        setSaveButtonDisable(false);
      } else {
        setinformationDialogOkButton(true);
        setDialogTitleMode("ValidationDialogMode");
        setValidationDialogContent("Payment Failed to Insert.");
        setValidationDialogTitle("Information");
        setValidationDialogOpen(true);
        setSaveButtonDisable(false);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      setSaveButtonDisable(false);
      console.log(error);
      throw Error(error);
    }
  };
  function handleOnCellKeyDown(params, event) {
    console.log(params, event);
    if (params.field === "debitAmount") {
      const dataIndex = rows.findIndex((data) => {
        return data.id === params.id;
      });
      let data = rows[dataIndex];
      const datas = {
        ...data,
        debitAmount:
          event.target.value <= 0 || Number(event.target.value) > 99999999
            ? 0
            : Math.floor(event.target.value),
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentReducerAction.updateRows(newItem));
    }
  }
  return (
    <>
      <Box
        sx={{
          color: "red",
          background: "white",
          padding: "0.8rem",
          borderRadius: "0.4rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            marginBottom: "8px",
          }}
        >
          <Tooltip title="Ctrl+A">
            <Button
              variant="contained"
              onClick={gridRowAddButtonHandler}
              sx={{
                marginLeft: "1rem",
                color: "white",
                fontWeight: "bold",
              }}
              ref={addRowRef}
            >
              <AddIcon />
            </Button>
          </Tooltip>

          <Tooltip title="Ctrl+S">
            <Button
              sx={{ fontWeight: "bold", marginLeft: "12px" }}
              variant="contained"
              onClick={dummySaveButtonHandler}
              disabled={saveButtonDisable || rows.length <= 0}
              ref={saveRef}
            >
              <SaveIcon />
            </Button>
          </Tooltip>
        </Box>
        {useMediaQuery("(min-width:1200px)") && (
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            rows={rows}
            gridHeight={
              rows.length < 5 && rows.length !== 0
                ? rows.length * 40 + 130
                : 330
            }
            onRowClick={(params) => {
              setActiveRowID(params.id);
            }}
            onPageSizeChange={(pageSize) => {
              setPageSize(pageSize);
            }}
            onCellDoubleClick={(params) => {
              cellDoubleClickHandler(params);
            }}
            columns={columnsData}
            pageSize={pageSize}
            pageSizeOptions={[5, 10, 15, 20, 25]}
            // onRowClick={(params) => {
            //   setRowId(params.id);
            //   setDisabled(false);
            // }}
            isCellEditable={() => true}
            onCellEditCommit={(params) => {
              cellChangeHandler(params);
            }}
            onCellKeyDown={(params, event) => {
              (event.key === "e" ||
                event.key === "E" ||
                event.key === "." ||
                event.key.includes("-")) &&
                event.preventDefault();
              handleOnCellKeyDown(params, event);
            }}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
          />
        )}
        {useMediaQuery("(max-width:1200px)") && (
          <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
            <React.Fragment>
              <Grid
                container
                item
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-end"
                sx={{ height: "60px", bgcolor: "white" }}
              >
                {totalRowsCount > 10 && (
                  <Typography
                    sx={{
                      mr: 2,
                      color: "#004A92",
                      fontWeight: 700,
                    }}
                  >
                    {"Page Max Records : " + rowsPerPage}
                  </Typography>
                )}
                <Typography
                  padding="1px"
                  sx={{
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Total Records : " + totalRowsCount}
                </Typography>
                <Pagination
                  count={totalPageCount}
                  color="primary"
                  onChange={handlePageChange}
                  page={page}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{ previous: ArrowBack, next: ArrowForward }}
                      {...item}
                    />
                  )}
                />
              </Grid>
              <Grid container>
                <Box
                  sx={{
                    height: accordianOpen
                      ? window.innerHeight - 540
                      : window.innerHeight - 250,
                    overflow: "auto",
                    flex: "1 auto",
                    marginBottom: "16px",
                  }}
                >
                  {datarows.map((row, index) => (
                    <React.Fragment>
                      <Grid
                        container
                        direction="column"
                        sx={{ flex: "1 auto" }}
                      >
                        <Card>
                          <CardHeader
                            subheader={
                              "Branch - GLAcc : " +
                              row.applicationBranch +
                              " - " +
                              row.glAccount
                            }
                            subheaderTypographyProps={{
                              color: "#004A92",
                              fontWeight: "700",
                            }}
                            action={
                              <React.Fragment>
                                {row.applicationNumber && (
                                  <IconButton
                                    onClick={() => {
                                      let params = {
                                        row: row,
                                      };
                                      customerBankDetailDialogHandler(params);
                                    }}
                                  >
                                    <AccountBalanceIcon />
                                  </IconButton>
                                )}
                                <IconButton size="small">
                                  <Delete
                                    fontSize="small"
                                    sx={{ color: "#004A92", fontWeight: 700 }}
                                    onClick={() => {
                                      let params = {
                                        id: row.id,
                                      };
                                      deleteSelectedRow(params);
                                    }}
                                  />
                                </IconButton>
                              </React.Fragment>
                            }
                            sx={{
                              textAlign: "left",
                              padding: "16px 16px 0px 16px !important",
                            }}
                          />
                          <CardContent sx={{}}>
                            <Grid
                              container
                              item
                              direction="column"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                              sx={{}}
                            >
                              <Grid
                                container
                                rowSpacing={1}
                                direction="row"
                                alignItems="flex-start"
                                justifyContent="flex-start"
                              >
                                <React.Fragment>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Branch"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` :  `}

                                      <CustomAutoComplete
                                        variant="standard"
                                        type="text"
                                        placeholder="Select Branch"
                                        autoCompleteValues={filterValues.branch.map(
                                          (data) => data.label
                                        )}
                                        value={row.applicationBranch}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "applicationBranch",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                          setActiveRowID(params.id);
                                        }}
                                      />
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Application Number"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}

                                      <CustomAutoComplete
                                        variant="standard"
                                        type="text"
                                        placeholder="Select Application Number"
                                        autoCompleteValues={applicationArray}
                                        value={row.applicationNumber}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "applicationNumber",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                          setActiveRowID(params.id);
                                        }}
                                        onOpen={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "applicationNumber",
                                            value: value,
                                          };
                                          cellDoubleClickHandler(params);
                                        }}
                                      />
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"GL Account"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}

                                      <CustomAutoComplete
                                        variant="standard"
                                        type="text"
                                        placeholder="Select Gl Account"
                                        autoCompleteValues={GLAccountArray}
                                        value={row.glAccount}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "glAccount",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                          setActiveRowID(params.id);
                                        }}
                                        onOpen={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "glAccount",
                                            value: value,
                                          };
                                          cellDoubleClickHandler(params);
                                        }}
                                      />
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Gl Account Desc"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${
                                      row.description !== null &&
                                      row.description !== undefined &&
                                      row.description !== ""
                                        ? row.description
                                        : "-----------------------"
                                    }`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Credit Amount"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}

                                    <TextField
                                      autoComplete="off"
                                      sx={{
                                        "& .MuiInputBase-input": {
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        },
                                      }}
                                      inputProps={{
                                        // inputMode: "numeric",
                                        // pattern: "[0-9]*",
                                        style: {
                                          textAlign: `left`,
                                          fontSize: "12px",
                                        },
                                      }}
                                      type="number"
                                      variant="standard"
                                      value={row.debitAmount}
                                      placeholder="Please Enter Debit Amount"
                                      onChange={(event) => {
                                        let params = {
                                          id: row.id,
                                          field: "debitAmount",
                                          value: event.target.value,
                                        };
                                        cellChangeHandler(params);
                                        setActiveRowID(params.id);
                                      }}
                                      onBlur={() => {}}
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "e" ||
                                          e.key === "E" ||
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "."
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </Grid>
                                </React.Fragment>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Divider />
                    </React.Fragment>
                  ))}
                  {datarows.length === 0 && (
                    <NoDataFound
                      message={"No Data Found."}
                      imageStyle={{
                        marginTop:
                          accordianOpen && window.innerHeight < 1000
                            ? "20px"
                            : "20%",
                      }}
                    />
                  )}
                </Box>
              </Grid>
            </React.Fragment>
          </Paper>
        )}
      </Box>
      <Dialog
        // sx={{
        //   "& div.css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
        //     maxWidth: { xs: "95%", md: "95%", lg: "95%" },
        //   },
        // }}
        open={Dialogopen}
      >
        <DialogTitle>
          <h4>Bank Details</h4>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              padding: "8px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  variant="standard"
                  label="Applicant Name"
                  value={modalValues.customerName}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Bank Name"
                  variant="standard"
                  value={modalValues.bankName}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Bank Branch Name"
                  variant="standard"
                  value={modalValues.bankBranchName}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomDateField
                  label="EMI Start Date"
                  variant="standard"
                  disabled={true}
                  value={modalValues.emiStartDate}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="IFSC"
                  variant="standard"
                  value={modalValues.ifsc}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Bank Account Number"
                  variant="standard"
                  value={modalValues.bankAccNum}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  variant="standard"
                  type="text"
                  label="Account Type"
                  value={modalValues.accountType}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Current EMI"
                  variant="standard"
                  disabled={true}
                  value={
                    modalValues.emiAmt !== ""
                      ? parseInt(modalValues.emiAmt).toLocaleString("en-IN")
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              ref={okRef}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={validationDialogOpen}
        sx={{
          "& div.css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            maxWidth: { xs: "95%", md: "95%", lg: "95%" },
          },
        }}
      >
        <DialogTitle>
          <h4>{validationDialogTitle}</h4>
        </DialogTitle>
        <DialogContent>{validationDialogContent}</DialogContent>
        <DialogActions>
          {!informationDialogOkButton && (
            <Tooltip title="Ctrl+K" placement="top">
              <Button
                onClick={() => {
                  window.location.reload(true);
                  setValidationDialogOpen(false);
                }}
                ref={okValRef}
              >
                OK
              </Button>
            </Tooltip>
          )}
          {informationDialogOkButton && (
            <Tooltip title="Ctrl+K" placement="top">
              <Button
                onClick={() => {
                  setValidationDialogOpen(false);
                }}
                ref={okInfoRef}
              >
                OK
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmationDialogOpen}
        sx={{
          "& div.css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            maxWidth: { xs: "95%", md: "95%", lg: "95%" },
          },
        }}
      >
        <DialogTitle>
          <h4>{confirmationDialogTitle}</h4>
        </DialogTitle>
        <DialogContent>{confirmationDialogContent}</DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => {
                setConfirmationDialogopen(false);
              }}
              ref={cancelRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              disabled={yesButtonDisableHandler}
              onClick={() => {
                confirmationDialogOkButtonHandler();
              }}
              ref={yesRef}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog open={informationDialogFlag}>
        <DialogTitle>
          <h4>Information</h4>
        </DialogTitle>
        <DialogContent>{informationDialogTitle}</DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              disabled={yesButtonDisableHandler}
              onClick={() => {
                setInformationDialogFlag(false);
              }}
            >
              Ok
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
    </>
  );
};

export default FilePaymentDetail;
